<template>
  <section class="frequent-searches-block">
    <div class="general-info__container">
      <h2 v-if="heading" id="paid-popular-title" class="paid-popular__title">{{ heading }}</h2>
      <div class="frequent-searches-block__grid">
        <div
          v-for="(item, idx) in items"
          :key="idx"
          class="frequent-searches-block__cell"
          :style="{ cursor: item.link ? 'pointer' : 'default' }"
          @click="goTo(item)"
        >
          <div class="frequent-searches-block__image-wrap">
            <img
              v-if="item.image"
              :src="item.image"
              :alt="item.caption || ''"
              class="frequent-searches-block__image"
            >
          </div>
          <p v-if="item.caption" class="frequent-searches-block__caption">{{ item.caption }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppFrequentSearchesBlock',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    heading() {
      return (this.data && this.data.heading) || ''
    },
    items() {
      const list = this.data && this.data.items
      return Array.isArray(list) ? list : []
    },
  },
  methods: {
    normalizeLink(link) {
      const raw = String(link || '').trim()
      if (!raw) return ''
      if (/^https?:\/\//i.test(raw)) return raw
      if (raw.startsWith('/')) return raw
      return `/${raw}`
    },
    goTo(item) {
      const href = this.normalizeLink(item && item.link)
      if (!href) return
      if (/^https?:\/\//i.test(href)) {
        window.location.href = href
        return
      }
      // Ссылки с якорем (#) — через window.location, чтобы браузер обработал скролл
      if (href.includes('#')) {
        window.location.href = href
        return
      }
      this.$router.push(href).catch(() => {})
    },
  },
}
</script>

<style scoped lang="scss">
.frequent-searches-block {
  width: 100%;
}

.frequent-searches-block__grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  margin-top: 20px;
}

.frequent-searches-block__cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 14px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: rgba(#66cc66, 0.55);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.04);
  }
}

.frequent-searches-block__image-wrap {
  width: 100%;
  height: 100px;
  border-radius: 12px;
  overflow: hidden;
}

.frequent-searches-block__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.frequent-searches-block__caption {
  margin: 10px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: center;
  line-height: 1.3;
}

@media (max-width: 1024px) {
  .frequent-searches-block__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 600px) {
  .frequent-searches-block__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
